import { DynamicType } from '../../thematics/models/dynamic.model';
import { CreditCosts } from '../../organizations/models/organizations.entity';

/**
 * Credit costs for different train/service types.
 * System: 1-10-10 (Orientation: 1, Speech: 10, Coaching: 10)
 *
 * Update these values to change credit costs across the entire application.
 */
export const CREDIT_COSTS = {
  ORIENTATION_CALL: 1,
  SPEECH_TRAIN: 10,      // Parole en groupe
  COACHING_TRAIN: 10,    // Coaching en groupe
} as const;

export const LEGACY_CREDIT_COSTS: CreditCosts = {
  orientationCall: CREDIT_COSTS.ORIENTATION_CALL,
  speechTrain: CREDIT_COSTS.SPEECH_TRAIN,
  coachingTrain: CREDIT_COSTS.COACHING_TRAIN,
};

/**
 * Number of sessions per parcours
 */
export const PARCOURS_SESSION_COUNT = 4;

/**
 * Get required credits for a given dynamic type
 */
export function getRequiredCredits(
  dynamicType: DynamicType,
  creditCosts: CreditCosts = LEGACY_CREDIT_COSTS,
): number {
  return dynamicType === DynamicType.COACHING
    ? creditCosts.coachingTrain
    : creditCosts.speechTrain;
}

/**
 * Credit information display strings for UI
 * These are used in templates to show credit equivalencies
 */
export function buildCreditInfo(
  creditCosts: CreditCosts = LEGACY_CREDIT_COSTS,
  options?: { orientationCallOffered?: boolean },
) {
  const orientationCallOffered = options?.orientationCallOffered ?? creditCosts.orientationCall === 0;

  return {
    orientationCall: {
      credits: creditCosts.orientationCall,
      label: orientationCallOffered
        ? `Appel d'orientation offert`
        : `${creditCosts.orientationCall} crédit = 1 appel d'orientation`,
    },
    speechTrain: {
      credits: creditCosts.speechTrain,
      label: `${creditCosts.speechTrain} crédits = 1 parcours de Parole de ${PARCOURS_SESSION_COUNT} séances`,
      shortLabel: `${creditCosts.speechTrain} crédits = 1 parcours de Parole`,
    },
    coachingTrain: {
      credits: creditCosts.coachingTrain,
      label: `${creditCosts.coachingTrain} crédits = 1 parcours de Coaching de ${PARCOURS_SESSION_COUNT} séances`,
      shortLabel: `${creditCosts.coachingTrain} crédits = 1 parcours de Coaching`,
    },
  } as const;
}

export const CREDIT_INFO = buildCreditInfo();

/**
 * Helper type for credit info keys
 */
export type CreditInfoKey = keyof typeof CREDIT_INFO;
